(() => {
  'use strict';

  // ========================================
  // DIRECT GLOBAL.JS OVERRIDE (PRODUCTION)
  // ========================================

  const overrideGlobalMethods = () => {
    let globalJSDetected = false;

    // Multiple detection methods (silent)
    if (typeof window.QuantityInput !== 'undefined') {
      globalJSDetected = true;
    }

    if (!globalJSDetected && typeof customElements !== 'undefined') {
      const quantityInputElement = customElements.get('quantity-input');
      if (quantityInputElement) {
        globalJSDetected = true;
      }
    }

    if (!globalJSDetected) {
      const quantityElements = document.querySelectorAll('quantity-input, .quantity-input, [data-quantity]');
      if (quantityElements.length > 0) {
        globalJSDetected = true;
      }
    }

    if (!globalJSDetected) {
      const quantityButtons = document.querySelectorAll('button[name="plus"], button[name="minus"], [data-action="increment"], [data-action="decrement"]');
      if (quantityButtons.length > 0) {
        globalJSDetected = true;
      }
    }

    if (!globalJSDetected && window.location.pathname) {
      if (window.location.pathname.includes('/products/') || window.location.pathname.includes('/cart')) {
        globalJSDetected = true;
      }
    }

    if (globalJSDetected) {
      // Override QuantityInput if available
      if (typeof window.QuantityInput !== 'undefined') {
        const originalOnButtonClick = window.QuantityInput.prototype.onButtonClick;
        const originalOnInputChange = window.QuantityInput.prototype.onInputChange;
        const originalNormalize = window.QuantityInput.prototype.normalize;

        // Block E-invitation button clicks
        window.QuantityInput.prototype.onButtonClick = function(event) {
          if (this.isEInvitation && this.isEInvitation()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return false;
          }
          return originalOnButtonClick.call(this, event);
        };

        // Block E-invitation input changes
        window.QuantityInput.prototype.onInputChange = function(event) {
          if (this.isEInvitation && this.isEInvitation()) {
            if (this.input) {
              this.input.value = "1";
            }
            return;
          }
          return originalOnInputChange.call(this, event);
        };

        // Block E-invitation normalization
        window.QuantityInput.prototype.normalize = function(val, element) {
          if (this.isEInvitation && this.isEInvitation()) {
            return 1;
          }
          return originalNormalize.call(this, val, element);
        };
      }

      // Override quantity buttons directly
      overrideQuantityButtons();

    } else {
      // Retry with increasing delay
      const retryCount = (window.overrideRetryCount || 0) + 1;
      window.overrideRetryCount = retryCount;

      if (retryCount < 20) { // Reduced from 50 to 20 for performance
        setTimeout(overrideGlobalMethods, 100 + (retryCount * 5));
      } else {
        overrideQuantityButtons(); // Fallback
      }
    }
  };

  // Fallback: Override quantity buttons directly
  const overrideQuantityButtons = () => {
    document.addEventListener('click', (e) => {
      const button = e.target.closest('button[name="plus"], button[name="minus"], [data-action="increment"], [data-action="decrement"]');

      if (button) {
        const container = button.closest('quantity-input, .quantity, .quantity-selector, form, .product');
        let isEInvitation = false;

        if (container) {
          const input = container.querySelector('input[name="quantity"], input[name="updates[]"]');
          if (input) {
            const productContainer = input.closest('[data-product-type]');
            if (productContainer) {
              const productType = productContainer.dataset.productType || '';
              isEInvitation = productType.toLowerCase().includes('e-invit') ||
                             productType.toLowerCase().includes('einvit');
            }
          }
        }

        if (isEInvitation) {
          e.preventDefault();
          e.stopImmediatePropagation();

          const input = container?.querySelector('input[name="quantity"], input[name="updates[]"]');
          if (input) {
            input.value = "1";
          }

          return false;
        }
      }
    }, { capture: true });
  };

  // Initialize override system
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', overrideGlobalMethods);
  } else {
    overrideGlobalMethods();
  }

  // Try multiple times to catch global.js loading
  setTimeout(overrideGlobalMethods, 50);
  setTimeout(overrideGlobalMethods, 100);
  setTimeout(overrideGlobalMethods, 250);
  setTimeout(overrideGlobalMethods, 500);
})();